/* CPB rasterizes remote artwork to PNG, but retains the CDN URL as its filename.
   Send the real image format with a plain filename; never change image bytes. */
(function () {
  'use strict';
  if (window.__MYX_UPLOAD_FILENAME_GUARD__) return;
  window.__MYX_UPLOAD_FILENAME_GUARD__ = true;
  function uploadEndpoint(url) {
    try {
      var parsed = new URL(String(url), location.href);
      return parsed.origin === 'https://app.thecustomproductbuilder.com' && parsed.pathname === '/imageUpload';
    } catch (_) { return false; }
  }
  function filename(name, mime, buffer) {
    if (typeof name !== 'string' || !name) return name;
    var ext = null;
    // Only normalize image payloads whose actual format we can identify.
    if (typeof buffer === 'string' && /^iVBORw0KGgo/.test(buffer)) ext = 'png';
    else if (typeof buffer === 'string' && /^\/9j\//.test(buffer)) ext = 'jpg';
    else if (typeof buffer === 'string' && /^R0lGOD/.test(buffer)) ext = 'gif';
    if (!ext) return name;
    var plain = name.split(/[?#]/)[0].split(/[\\/]/).pop();
    plain = plain.replace(/\.[^.]*$/, '').replace(/[^a-zA-Z0-9._ -]/g, '_').slice(0,160) || 'design-artwork';
    return plain + '.' + ext;
  }
  function normalize(body) {
    var fields, kind;
    if (body instanceof FormData || body instanceof URLSearchParams) { fields = body; kind = 'fields'; }
    else if (typeof body === 'string') {
      if (body.trim().charAt(0) === '{') {
        try { fields = JSON.parse(body); kind = 'json'; } catch (_) { return body; }
      } else if (/file%5Boriginalname%5D=|file\[originalname\]=/i.test(body)) {
        fields = new URLSearchParams(body); kind = 'encoded';
      }
    }
    if (!fields) return body;
    var nested = kind === 'json' && fields.file && typeof fields.file === 'object';
    function get(key) { return kind === 'json' ? nested ? fields.file[key] : fields['file[' + key + ']'] : fields.get('file[' + key + ']'); }
    var previous = get('originalname'), next = filename(previous, get('mimetype'), get('buffer'));
    if (next === previous) return body;
    if (kind === 'json') {
      if (nested) fields.file.originalname = next; else fields['file[originalname]'] = next;
      return JSON.stringify(fields);
    }
    // Copy rather than mutating the uploader's own FormData.
    var result = kind === 'fields' && body instanceof FormData ? new FormData() : new URLSearchParams();
    fields.forEach(function (value,key) { result.append(key,value); });
    result.set('file[originalname]', next);
    return kind === 'encoded' ? result.toString() : result;
  }
  var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
  var requests = new WeakMap();
  XMLHttpRequest.prototype.open = function (method,url) {
    requests.set(this, String(method).toUpperCase() === 'POST' && uploadEndpoint(url));
    return open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (requests.get(this)) body = normalize(body);
    return send.call(this,body);
  };
  var fetch = window.fetch;
  window.fetch = function (input,init) {
    var url = typeof input === 'string' || input instanceof URL ? String(input) : input && input.url;
    var method = init && init.method || input && input.method || 'GET';
    if (String(method).toUpperCase() === 'POST' && uploadEndpoint(url) && init && init.body) {
      init = Object.assign({},init,{body:normalize(init.body)});
    }
    return fetch.call(this,input,init);
  };
})();

/* Direct-to-customizer experiment. The existing CPB save/cart verification stays authoritative. */
(function () {
  'use strict';
  if (window.MaytrixDirectCart) return;
  var dialog, trigger, busy = false, frame = 0;
  var root = document.documentElement;
  function node(tag, text, className) {
    var el = document.createElement(tag);
    if (text != null) el.textContent = text;
    if (className) el.className = className;
    return el;
  }
  function cleanValue(value) {
    var colors={'#fedcaf':'Warm White','#fc5509':'Orange','#ffffff':'White','#74c8ff':'Ice Blue'};
    var text=String(value||'').replace(/★\s*Most popular/ig,'').replace(/Standard\s*★/g,'Standard').trim();
    return colors[text.toLowerCase()]||text;
  }
  function hide() {
    if (dialog) { dialog.close(); dialog.remove(); dialog = null; }
    root.classList.remove('myx-direct-cart-pending');
  }
  function clearLoading() {
    document.body.classList.remove('myx-cart-loading');
    window.MyxUx?.hideLoader?.(true);
    var loader = document.getElementById('myx-review-loader');
    if (loader) loader.hidden = true;
  }
  var reviewPanel, reviewSource, reviewHeight, reviewColumn, reviewColumnInert;
  var mobileReview = window.matchMedia('(max-width: 999px)');
  function closeReview(restore, focus) {
    if (!reviewPanel) return;
    reviewPanel.remove(); reviewPanel = null;
    root.classList.remove('myx-mobile-purchase-review');
    if (reviewColumn) reviewColumn.inert = reviewColumnInert;
    if (restore) {
      if (reviewHeight) root.style.setProperty('--myx-premium-preview-height', reviewHeight);
      else root.style.removeProperty('--myx-premium-preview-height');
    }
    window.dispatchEvent(new Event('resize'));
    if (focus) reviewSource?.focus({preventScroll:true});
  }
  function editStep(label) {
    if (/delivery/i.test(label)) return 'delivery';
    if (/side|light style|light pattern|LED (?:bar )?color|text direction/i.test(label)) return 'sides';
    if (/design|logo|star|center|font|text color|text size/i.test(label)) return 'center';
    return 'frame';
  }
  function review(summary, source) {
    if (busy || !mobileReview.matches) return;
    if (reviewPanel) return;
    reviewSource = source;
    reviewHeight = root.style.getPropertyValue('--myx-premium-preview-height');
    reviewColumn = document.querySelector('#product-builder .cpb-panels-container');
    reviewColumnInert = reviewColumn?.inert || false;
    if (reviewColumn) reviewColumn.inert = true;
    reviewPanel = node('section', null, 'myx-mobile-purchase-review-panel');
    reviewPanel.setAttribute('aria-labelledby', 'myx-mobile-review-title');
    reviewPanel.innerHTML = '<header><h2 id="myx-mobile-review-title" tabindex="-1">Review &amp; purchase</h2><button type="button" class="myx-mobile-review-close" aria-label="Back to designing">×</button></header><div class="myx-mobile-review-scroll"><div class="myx-mobile-review-price"><span>Your price</span><div class="myx-mobile-review-prices"><strong></strong></div><small>Shipping included</small></div><p class="myx-mobile-review-intro">Check your choices below. You can edit anything before adding your mirror to the cart.</p><dl></dl><p class="myx-cart-reassurance">After purchase, a Maytrix designer will personally reach out to review your design, answer questions, and discuss any special requests.</p></div>';
    reviewPanel.querySelector('.myx-mobile-review-price strong').textContent = summary.price || 'Confirming price';
    if (summary.comparePrice && summary.comparePrice !== summary.price) {
      var compare = node('s', summary.comparePrice, 'myx-mobile-review-compare');
      compare.setAttribute('aria-label', 'Original price ' + summary.comparePrice);
      reviewPanel.querySelector('.myx-mobile-review-prices').append(compare);
    }
    var list = reviewPanel.querySelector('dl');
    var rows = (summary.rows || []).slice();
    var facts = rows.filter(function(row){return /^(Thickness|Estimated weight)$/i.test(row.label);});
    rows = rows.filter(function(row){return !/^(Thickness|Estimated weight)$/i.test(row.label);});
    if (facts.length) {
      var info = node('p', facts.map(function(row){return row.label + ': ' + cleanValue(row.value);}).join(' · '), 'myx-product-facts');
      reviewPanel.querySelector('.myx-mobile-review-price').append(info);
    }
    function addChoice(label, value) { if (value && !rows.some(function(row){return row.label===label;})) rows.push({label:label,value:value}); }
    function category(id) { return document.querySelector('[data-category-id="'+id+'"]'); }
    function choice(id) {
      var cat=category(id); if (!cat || !cat.getClientRects().length) return '';
      var chosen=cat.querySelector('[aria-pressed="true"],.cpb-option.cpb-active');
      if (!chosen) return '';
      return (chosen.getAttribute('aria-label') || chosen.getAttribute('data-myx-choice-label') || chosen.querySelector('.cpb-option-label')?.textContent || chosen.textContent || '').replace(/^Color option /,'').replace(/View example|Example/g,'').trim();
    }
    var font=category('isXiGLkqYyvCvXqsv4l0QLOX');
    if (font?.getClientRects().length) addChoice('Font',font.querySelector('.myx-font-picker-value')?.textContent);
    addChoice('Text color',choice('JTXoUcEXaLD_BdJU2yNZQFyU'));
    addChoice('Logo lighting',choice('PBO5FoiL7WyPoltf_adurqLd'));
    addChoice('Logo outline',choice('ewsqpkHYBWFEbxeuQx2MyANc'));
    addChoice('Mounting',document.querySelector('[data-myx-mount][aria-pressed="true"]')?.dataset.myxMount);
    var sideText=category('4qoRqj0Fds_iRKAoRemupDzi');
    if(sideText?.getClientRects().length) addChoice('Side text',sideText.querySelector('textarea,input')?.value);
    var sideFont=category('DkvYo6CNoHB87aIPnRYEvu8v');
    if(sideFont?.getClientRects().length) addChoice('Side font',sideFont.querySelector('.myx-font-picker-value')?.textContent);
    addChoice('Side text color',choice('QIKsaieim4U8XmKkOQ26QBAt'));
    addChoice('LED bar color',choice('gMkDYozZJBDN8GYrPVJS--NR') || choice('fD2kHs7C9MhutByPyc8Fup71'));
    rows.sort(function(a,b){var order={frame:0,center:1,sides:2,delivery:3};return order[editStep(a.label)]-order[editStep(b.label)];});
    rows.forEach(function (row) {
      var wrap = node('div'), details = node('div');
      details.append(node('dt', row.label), node('dd', cleanValue(row.value)));
      wrap.append(details);
      if (!/thickness|weight/i.test(row.label)) {
        var edit = node('button', 'Edit'); edit.type = 'button'; edit.setAttribute('aria-label', 'Edit ' + row.label.toLowerCase());
        edit.addEventListener('click', function () {
          closeReview(true, false);
          var step = document.querySelector('[data-myx-customizer-step="' + editStep(row.label) + '"]');
          step?.click(); step?.focus({preventScroll:true});
        });
        wrap.append(edit);
      }
      list.append(wrap);
    });
    reviewPanel.querySelector('.myx-mobile-review-close').addEventListener('click', function () { closeReview(true, true); });
    document.body.append(reviewPanel);
    root.classList.add('myx-mobile-purchase-review');
    var headerHeight = parseFloat(getComputedStyle(root).getPropertyValue('--myx-premium-header-height')) || 58;
    root.style.setProperty('--myx-premium-preview-height', Math.max(180, Math.round((innerHeight-headerHeight)*.27)) + 'px');
    window.dispatchEvent(new Event('resize'));
    requestAnimationFrame(function () { reviewPanel?.querySelector('h2').focus({preventScroll:true}); });
  }
  mobileReview.addEventListener('change', function () { if (!mobileReview.matches) closeReview(true, false); });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && reviewPanel) { event.preventDefault(); closeReview(true, true); } });
  document.addEventListener('maytrix:mobile-section-change', function () { closeReview(true, false); });

  function begin(summary, source) {
    closeReview(false, false);
    if (busy) return;
    busy = true; trigger = source;
    root.classList.add('myx-direct-cart-pending');
    document.body.classList.add('myx-cart-loading');
    window.MyxUx?.showLoader?.('Saving your infinity mirror design', 'bag');
    sync();
  }
  function error(message, uncertain) {
    busy = false;
    clearLoading();
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'myx-direct-cart myx-direct-cart-error';
      dialog.setAttribute('aria-labelledby', 'myx-direct-cart-title');
      dialog.innerHTML = '<header><h2 id="myx-direct-cart-title">Please check your cart</h2><button type="button" class="myx-direct-cart-close" aria-label="Close">×</button></header><section><p class="myx-direct-cart-status" role="alert"></p><div class="myx-direct-cart-recovery"></div></section>';
      dialog.querySelector('.myx-direct-cart-close').addEventListener('click', function(){hide();trigger?.focus({preventScroll:true});});
      dialog.addEventListener('cancel',function(event){event.preventDefault();hide();trigger?.focus({preventScroll:true});});
      document.body.append(dialog);dialog.showModal();
    }
    dialog.querySelector('.myx-direct-cart-status').textContent = message;
    var recovery = dialog.querySelector('.myx-direct-cart-recovery');
    recovery.hidden = false; recovery.replaceChildren();
    if (uncertain) {
      var link = node('a', 'Check your cart');
      var url = new URL('/cart', location.origin);
      if (window.Shopify?.theme?.role === 'unpublished') url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
      link.href = url.href; recovery.append(link);
    } else {
      var back = node('button', 'Back to your design'); back.type = 'button';
      back.addEventListener('click', function () { hide(); clearLoading(); trigger?.focus({preventScroll:true}); }); recovery.append(back);
    }
    sync();
  }
  function done() { busy = false; hide(); clearLoading(); sync(); document.getElementById('MaytrixCartClose')?.focus({preventScroll:true}); }
  function sync() {
    frame = 0;
    if (root.matches('.myx-mobile-hero,.myx-desktop-hero')) {
      document.querySelectorAll('.myx-customizer-mobilebar__finish,.myx-customizer-desktopbar__finish').forEach(function(button){
        if(button.textContent!=='DESIGN YOURS')button.textContent='DESIGN YOURS';
        if(button.getAttribute('aria-label')!=='Design Yours')button.setAttribute('aria-label','Design Yours');
      });
      return;
    }
    document.querySelectorAll('.myx-customizer-mobilebar__finish,.myx-customizer-desktopbar__finish').forEach(function (button) {
      var text = busy ? 'SAVING…' : 'Finish my design';
      if (button.textContent !== text) button.textContent = text;
      button.setAttribute('aria-label', busy ? 'Adding to cart' : 'Finish my design');
      button.disabled = busy;
      if (!busy) button.removeAttribute('aria-busy');
    });
    document.querySelectorAll('.myx-review-save-proxy').forEach(function (button) {
      if (button.textContent !== 'Finish my design') button.textContent = 'Finish my design';
      if (button.getAttribute('aria-label') !== 'Finish my design') button.setAttribute('aria-label', 'Finish my design');
    });
  }
  function queue() { if (!frame) frame = requestAnimationFrame(sync); }
  window.addEventListener('click', function (event) {
    if (root.matches('.myx-mobile-hero,.myx-desktop-hero')) return;
    var button = event.target.closest?.('.myx-customizer-mobilebar__finish,.myx-customizer-desktopbar__finish');
    if (!button || busy) return;
    event.preventDefault(); event.stopImmediatePropagation();
    window.dispatchEvent(new CustomEvent('maytrix:direct-add-request',{detail:{trigger:button,confirmed:!!reviewPanel}}));
  }, true);
  window.addEventListener('maytrix:bag-progress', function (event) {
    if (!busy) return;
    var stage = event.detail?.stage;
    if (stage === 'done') done();
    else if (stage === 'error') error('We couldn’t confirm the addition. Check your cart before trying again. Your design is saved.', true);
  });
  window.addEventListener('click',function(event){
    var link=event.target.closest?.('#MaytrixCartDrawer a[data-myx-load-product]');if(!link)return;
    var url=new URL(link.getAttribute('href').replace(/&amp;/g,'&'),location.origin);
    url.searchParams.delete('review');url.searchParams.delete('view');
    var key=link.closest('[data-cart-key]')?.dataset.cartKey;
    if(key)url.searchParams.set('myxedit',key);
    if(window.Shopify?.theme?.role==='unpublished')url.searchParams.set('preview_theme_id',window.Shopify.theme.id);
    link.href=url.href;
  },true);
  document.addEventListener('keydown',function(event){
    var cart=document.getElementById('MaytrixCartDrawer');
    if(event.key!=='Tab'||!cart||!document.body.classList.contains('mtx-cart-open'))return;
    var focusable=[...cart.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')].filter(el=>el.getClientRects().length);
    var first=focusable[0],last=focusable[focusable.length-1];
    if(!first)return;
    if(event.shiftKey&&(document.activeElement===first||!cart.contains(document.activeElement))){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&(document.activeElement===last||!cart.contains(document.activeElement))){event.preventDefault();first.focus();}
  },true);
  window.addEventListener('maytrix:cart-drawer-closed',function(){trigger?.focus({preventScroll:true});});
  window.MaytrixDirectCart = {begin:begin, review:review, error:error, done:done, needsInput:done};
  new MutationObserver(queue).observe(root, {attributes:true, attributeFilter:['data-myx-mobile-step','class']});
  new MutationObserver(queue).observe(document.body, {childList:true, characterData:true, subtree:true});
  // A restored browser page can retain a scheduled frame ID whose callback was
  // discarded. Reconcile the visible purchase controls immediately on return.
  function resume(){if(frame)cancelAnimationFrame(frame);frame=0;sync();}
  window.addEventListener('pageshow',resume);
  window.addEventListener('popstate',resume);
  window.addEventListener('focus',queue);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)resume();});
  window.addEventListener('maytrix:mobile-drawer-open',queue);
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED',queue);
  sync();
})();
